// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"chatWindow_wrapper_1CUVP1r","headerTitle":"chatWindow_headerTitle_1mHSyqQ","videoWrapper":"chatWindow_videoWrapper_3W1xjNZ"};